<template>
  <div id="status">
    <el-form label-position="left" class="m-4 text-left">
      <el-form-item label-width="25%" size="mini">
        <template slot="label">
          <i class="fa fa-fw fa-bars"></i>
          状态
        </template>
        <el-select v-model="data.Status" filterable placeholder="请选择" style="width:100%">
          <el-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <small class="color-gray mt-2"></small>
        <van-tag plain size="small">{{options[data.Status-1].tips}}</van-tag>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "status",
  data() {
    return {
      options: [
        {
          value: 1,
          label: "正常完成",
          tips: "工作任务完成后可直接点上报工作任务情况。"
        },
        {
          value: 2,
          label: "未完成",
          tips: "因受到外界影响导致工作无法进行，需提交未完成状态。"
        },
        {
          value: 3,
          label: "上报异常",
          tips: "工作过程中受到影响不能在上报时间内完成，可提交异常状态。"
        }
      ]
    };
  },
  props: {
    data: Object
  },
  methods: {},
  created() {}
};
</script>

<style scoped>
</style>